// Classes
import { ProspectProfileReducerState } from "Containers/Filter/ProspectProfile/classes/prospectProfile.classes";
import { AttributeObject } from "../classes/attributes.classes";

/**
 * @function getIntendedLevelofStudyAttributes
 *
 * Post-processes the attributes for this section of the filter
 *
 * @param {ProspectProfileReducerState} prospectProfile - The current state
 * of the Prospect Profile filter section.
 * @return {AttributeObject | undefined}
 *
 * @example
 *
 *     getIntendedLevelofStudyAttributes(prospectProfile)
 */
export const getIntendedLevelofStudyAttributes = (
  prospectProfile: ProspectProfileReducerState
) => {
  let attributeObject = undefined;

  if (prospectProfile.intendedLevelOfStudy !== "Any") {
    attributeObject = new AttributeObject(
      prospectProfile.intendedLevelOfStudy,
      "standard"
    );
  }

  return attributeObject;
};
try {
    // @ts-ignore
    getIntendedLevelofStudyAttributes.displayName = "getIntendedLevelofStudyAttributes";
    // @ts-ignore
    getIntendedLevelofStudyAttributes.__docgenInfo = { "description": "", "displayName": "getIntendedLevelofStudyAttributes", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Attributes/utilities/getIntendedLevelOfStudyAttributes.ts#getIntendedLevelofStudyAttributes"] = { docgenInfo: getIntendedLevelofStudyAttributes.__docgenInfo, name: "getIntendedLevelofStudyAttributes", path: "src/shared/containers/Attributes/utilities/getIntendedLevelOfStudyAttributes.ts#getIntendedLevelofStudyAttributes" };
}
catch (__react_docgen_typescript_loader_error) { }